const checkIsChildNode = ({ node, parentNode }) => {
  let currentNode = node

  while (currentNode) {
    if (currentNode === parentNode) {
      return true
    }

    currentNode = currentNode.parentNode
  }

  return false
}


export default checkIsChildNode
